import ApiService from '../../services/ApiService'

export class ContactLines {
  constructor(map) {
    this.map = map

    this.contactLinesSource = {
      type: 'FeatureCollection',
      features: []
    }
  }

  async init() {
    return new Promise(resolve => {
      let that = this
      let map = this.map
      map.on('load', function () {
        if (!map.getSource('contactLines')) {
          map.addSource('contactLines', {
            type: 'geojson',
            data: that.contactLinesSource
          })
        }
        if (!map.getLayer('contactLine')) {
          map.addLayer({
            id: 'contactLine',
            type: 'line',
            source: 'contactLines',
            paint: {
              'line-color': 'SaddleBrown',
              'line-width': 2,
              'line-opacity': 0.8
            }
          }, 'points')
        }
        resolve()
      })
    })
  }

  _update() {
    let s = this.map.getSource('contactLines')
    if (s !== undefined) {
      s.setData(this.contactLinesSource)
    }
  }
  async setData(selectedPeople, pointSource) {
    let extraContacts = await ApiService.whoseContacts(selectedPeople.map(o => o._id))
    extraContacts.data ? (extraContacts = extraContacts.data) : (extraContacts = [])
    for (const selectedPerson of selectedPeople) {
      let contactIds = selectedPerson.contacts.map(o => o.contactId)
      const ec = extraContacts.find(o => o._id === selectedPerson._id)
      if (ec) {
        contactIds = contactIds.concat(ec.contacts)
      }
      const actualContacts = pointSource.features.filter(o =>
        contactIds.includes(o.properties.id)
      )
      let personPos = pointSource.features.find(
        o => o.properties.id === selectedPerson._id
      ).geometry.coordinates
      for (const c of actualContacts) {
        let line = {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates: [personPos, c.geometry.coordinates]
          }
        }
        this.contactLinesSource.features.push(line)
      }
    }
    this._update()
  }
  clearData() {
    this.contactLinesSource = {
      type: 'FeatureCollection',
      features: []
    }
    this._update()
  }
}